import type {AxiosResponse} from "axios";

export function downloadAsFile(resp: AxiosResponse, filename: string) {
    const url = URL.createObjectURL(new Blob([resp.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    link.parentNode?.removeChild(link);
}
